export default __webpack_public_path__ + "media/images/users/user-cristal-smith-270x320-eef1046b823146b89c52016f02b665a1.jpg";